import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography/Typography';
import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon/Icon';
import { translate } from 'react-admin';

const styles = {
  icon: {
    paddingLeft: 9,
    '&&> span': {
      fontSize: 17,
    },
    '&&:hover': {
      cursor: 'pointer',
    },
  },
};

export const ProductsSummaryListItem = ({ expand, label, cost, qty, className, onExpand, expanded, translation = true, key, classes, translate }) => {
  return (
    <Grid container alignItems="center" className={className} key={key}>
      <Grid item xs={1} className={classes.icon}>
        {expand ?
          <Icon onClick={() => onExpand(label)}>
            {expanded === label ? 'expand_more' : 'chevron_right'}
          </Icon> : null}
      </Grid>
      <Grid item xs={1}>
        <Typography>{qty}</Typography>
      </Grid>
      <Grid item xs={8} className="label">
        <Typography>
          {translation ? translate(label) : label}
        </Typography>
      </Grid>
      <Grid item xs={2}>
        <Typography>{cost}</Typography>
      </Grid>
    </Grid>);
};

export default withStyles(styles)(translate(ProductsSummaryListItem));
